import { testimonialsSlider } from '../components/testimonials-slider';

testimonialsSlider('#testimonials-slider');